import Crud from '../views/TipoProfissional/Crud'
import Entity from '../views/TipoProfissional/Add'

let routes = {
    path: '/tipo_profissional',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/tipo_profissional/add',
            name: 'NovoAuxilio',
            component: Entity
        },
        {
            path: '/tipo_profissional/edit/:id?',
            name: 'EditarAuxilio',
            component: Entity
        },
        {
            path: '/tipo_profissional',
            name: 'list-tipo-profissional',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Tipos de Profissionais',
                breadcrumb: [
                    {
                        text: 'Tipos de Profissionais',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
